import { kymw1318Handlers } from "./kymw1318-handlers";
import { KYMW1319Handlers } from "./kymw1319-handlers";
import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";
import { ResponseUtils } from '../response-utils';

export const kymw13Handlers = [
  ...kymw1318Handlers,
  ...KYMW1319Handlers,

  // 媒体一覧取得 /kymw13/getPlanGoodsMedium
  http.post(PlessService.SERVICE.getPlanGoodsMedium.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getPlanGoodsMediumResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集コード一覧取得 /kymw13/getFeatureCodeList
  http.post(PlessService.SERVICE.KYMW13GetFeatureCodeList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getFeatureCodeListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 束ね企画回情報一覧取得 /kymw13/getBundleCatalogRoundInfoList
  http.post(PlessService.SERVICE.getBundleCatalogRoundInfoList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getBundleCatalogRoundInfoListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選択済一覧取得 /kymw13/getSelectedList
  http.post(PlessService.SERVICE.getSelectedList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getSelectedListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 予算・計画数一覧取得 /kymw13/getPlanNumList
  http.post(PlessService.SERVICE.getPlanNumList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getPlanNumListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定候補一覧取得 /kymw13/getPlanTargetList
  http.post(PlessService.SERVICE.getPlanTargetList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getPlanTargetListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定解除処理 /kymw13/deletePlan
  http.post(PlessService.SERVICE.deletePlan.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(deletePlanResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定解除確認処理 /kymw13/checkDeletePlan
  http.post(PlessService.SERVICE.checkDeletePlan.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(checkDeletePlanResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定確認処理 /kymw13/checkRegistPlan
  http.post(PlessService.SERVICE.checkRegistPlan.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(checkRegistPlanResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定処理/kymw13/registPlanResponse
  http.post(PlessService.SERVICE.registPlan.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(registPlanResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  http.post(PlessService.SERVICE.getSetPlanPromotionGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getSetPlanPromotionGoodsInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  http.post(PlessService.SERVICE.getSetPlanGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getSetPlanGoodsInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getPlanGoodsMediumResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        MediumType: "001",
        MediumName: "媒体名1",
        BundleCatalogFlag: "1",
        DutiesFormDiv: "1",
        MediumGroupDiv: "01",
      },
      {
        MediumType: "003",
        MediumName: "媒体名3",
        BundleCatalogFlag: "1",
        DutiesFormDiv: "2",
        MediumGroupDiv: "10",
      },
      {
        MediumType: "004",
        MediumName: "媒体名2",
        BundleCatalogFlag: "0",
        DutiesFormDiv: "1",
        MediumGroupDiv: "02",
      }
    ]
  }
}

const getFeatureCodeListResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      FeatureCodeList: [
        {
          FeatureCode: "00100",
          FeatureName: "特集テスト"
        },
        {
          FeatureCode: "001H1",
          FeatureName: "特集テスト"
        }
      ]
    }
  }
}

const getBundleCatalogRoundInfoListResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      BundleCatalogRoundList: [
        {
          BundleCatalogRoundId: "20250101",
          MediumType: "001",
          MediumName: "媒体名1",
          StartOrderCode: "2023300",
          EndOrderCode: "2024030",
          BundleCatalogRoundName: "束ね企画名1",
          BundleCatalogOrderCodeList: [
            "2023300", "2024020", "2024030"
          ],
          DelivCatalogId: "2023年10月02回",
        },
        {
          BundleCatalogRoundId: "20252222",
          MediumType: "002",
          MediumName: "媒体名2",
          StartOrderCode: "2023170",
          EndOrderCode: "2024060",
          BundleCatalogRoundName: "束ね企画名2",
          BundleCatalogOrderCodeList: [
            "2023160", "2024050", "2024060"
          ],
          DelivCatalogId: "2023年10月03回",
        }
      ]
    }

  }
}

const getSelectedListResponse = {

  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      TotalNum: 1,
      StartDispNum: 1,
      EndDispNum: 1,
      SelectedList: [
        {
          Status: "0",
          ClassCode: "01",
          SmallClassCode: "010000",
          GuideGoodsName: "ハウスみかん",
          GuideStandardName: "２５０ｇ（４～７個）",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          RelateMasterCode: "",
          PCode: "P1199536",
          ItemCodeIB: "1199536",
          ItemCodeTO: "1199536",
          ItemCodeGU: "1199536",
          ItemCodeTI: "1199536",
          ItemCodeSA: "1199536",
          ItemCodeTK: "1199536",
          ItemCodeNA: "1199536",
          ItemCodeNI: "1199536",
          JanCodeIB: "0400003351114",
          JanCodeTO: "0400003351114",
          JanCodeGU: "0400003351114",
          JanCodeTI: "0400003351114",
          JanCodeSA: "0400003351114",
          JanCodeTK: "0400003351114",
          JanCodeNA: "0400003351114",
          JanCodeNI: "0400003351114",
          GuideTempZoneName: "",
          BuyerCode: "00100001",
          PublishPageNumIB: 26,
          PublishPageNumTO: 26,
          PublishPageNumGU: 26,
          PublishPageNumTI: 27,
          PublishPageNumSA: 26,
          PublishPageNumTK: 27,
          PublishPageNumNA: 27,
          PublishPageNumNI: 27,
          PublishAmountLimitNumIB: 7,
          PublishAmountLimitNumTO: 7,
          PublishAmountLimitNumGU: 7,
          PublishAmountLimitNumTI: 5,
          PublishAmountLimitNumSA: 7,
          PublishAmountLimitNumTK: 5,
          PublishAmountLimitNumNA: 4,
          PublishAmountLimitNumNI: 1,
          OrderNumIB: "259   ",
          OrderNumTO: "259   ",
          OrderNumGU: "259   ",
          OrderNumTI: "280   ",
          OrderNumSA: "259   ",
          OrderNumTK: "280   ",
          OrderNumNA: "281   ",
          OrderNumNI: "279   ",
          ThisTimeSupplyPriceIB: 580,
          ThisTimeSupplyPriceTO: 580,
          ThisTimeSupplyPriceGU: 580,
          ThisTimeSupplyPriceTI: 598,
          ThisTimeSupplyPriceSA: 580,
          ThisTimeSupplyPriceTK: 598,
          ThisTimeSupplyPriceNA: 598,
          ThisTimeSupplyPriceNI: 598,
          SupplyPriceOffPercentIB: -45.7,
          SupplyPriceOffPercentTO: -45.7,
          SupplyPriceOffPercentGU: -45.7,
          SupplyPriceOffPercentTI: -50.3,
          SupplyPriceOffPercentSA: -45.7,
          SupplyPriceOffPercentTK: -50.3,
          SupplyPriceOffPercentNA: -50.3,
          SupplyPriceOffPercentNI: -50.3,
          SupplyPriceStandardIB: 398,
          SupplyPriceStandardTO: 398,
          SupplyPriceStandardGU: 398,
          SupplyPriceStandardTI: 398,
          SupplyPriceStandardSA: 398,
          SupplyPriceStandardTK: 398,
          SupplyPriceStandardNA: 398,
          SupplyPriceStandardNI: 398,
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: 8,
          ThisTimeCostPriceIB: 280,
          ThisTimeCostPriceTO: 280,
          ThisTimeCostPriceGU: 280,
          ThisTimeCostPriceTI: 280,
          ThisTimeCostPriceSA: 280,
          ThisTimeCostPriceTK: 280,
          ThisTimeCostPriceNA: 280,
          ThisTimeCostPriceNI: 280,
          CostPriceStandardIB: 280,
          CostPriceStandardTO: 280,
          CostPriceStandardGU: 280,
          CostPriceStandardTI: 280,
          CostPriceStandardSA: 280,
          CostPriceStandardTK: 280,
          CostPriceStandardNA: 280,
          CostPriceStandardNI: 280,
          BundlePriceIB: 1,
          BundlePriceTO: 1,
          BundlePriceGU: 1,
          BundlePriceTI: 1,
          BundlePriceSA: 1,
          BundlePriceTK: 1,
          BundlePriceNA: 1,
          BundlePriceNI: 1,
          GprIB: 51.7,
          GprTO: 51.7,
          GprGU: 51.7,
          GprTI: 53.2,
          GprSA: 51.7,
          GprTK: 53.2,
          GprNA: 53.2,
          GprNI: 53.2,
          GpIB: 210,
          GpTO: 150,
          GpGU: 150,
          GpTI: 604,
          GpSA: 600,
          GpTK: 954,
          GpNA: 223,
          GpNI: 127,
          GpALL: 3018,
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          PlanNumALL: 9700,
          PlanNumIB: 700,
          PlanNumTO: 500,
          PlanNumGU: 500,
          PlanNumTI: 1900,
          PlanNumSA: 2000,
          PlanNumTK: 3000,
          PlanNumNA: 700,
          PlanNumNI: 400,
          PlanPriceIB: 406,
          PlanPriceTO: 290,
          PlanPriceGU: 290,
          PlanPriceTI: 1136,
          PlanPriceSA: 1160,
          PlanPriceTK: 1794,
          PlanPriceNA: 419,
          PlanPriceNI: 239,
          PlanPriceALL: 5734,
          NextGuideIB: "",
          NextGuideTO: "",
          NextGuideGU: "",
          NextGuideTI: "",
          NextGuideSA: "",
          NextGuideTK: "",
          NextGuideNA: "",
          NextGuideNI: "",
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          PricePatternNameIB: "特価２",
          PricePatternNameTO: "特価２",
          PricePatternNameGU: "特価２",
          PricePatternNameTI: "特価２",
          PricePatternNameSA: "特価２",
          PricePatternNameTK: "特価２",
          PricePatternNameNA: "特価２",
          PricePatternNameNI: "特価２",
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          PromotionNoIB: "",
          PromotionNoTO: "",
          PromotionNoGU: "",
          PromotionNoTI: "",
          PromotionNoSA: "",
          PromotionNoTK: "",
          PromotionNoNA: "",
          PromotionNoNI: "",
          ApprovedPriceIB: null,
          ApprovedPriceTO: null,
          ApprovedPriceGU: null,
          ApprovedPriceTI: null,
          ApprovedPriceSA: null,
          ApprovedPriceTK: null,
          ApprovedPriceNA: null,
          ApprovedPriceNI: null,
          BuyerComment: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          NextGuideCheckIB: "0",
          NextGuideCheckTO: "0",
          NextGuideCheckGU: "0",
          NextGuideCheckTI: "0",
          NextGuideCheckSA: "0",
          NextGuideCheckTK: "0",
          NextGuideCheckNA: "0",
          NextGuideCheckNI: "0",
          MediumType: "123",
          SetPromotionNoIB: "",
          SetPromotionNoTO: "",
          SetPromotionNoGU: "",
          SetPromotionNoTI: "",
          SetPromotionNoSA: "",
          SetPromotionNoTK: "",
          SetPromotionNoNA: "",
          SetPromotionNoNI: "",
          KikakuRenrakuStatus: "10",
          KikakuRenrakuStatusName: "",
          KikakuRenrakuStatusBgColor: "",
          ResultGpIB: 288,
          ResultGpTO: 260,
          ResultGpGU: 233,
          ResultGpTI: 480,
          ResultGpSA: 934,
          ResultGpTK: 1066,
          ResultGpNA: 215,
          ResultGpNI: 143,
          ResultNumIB: 960,
          ResultNumTO: 866,
          ResultNumGU: 775,
          ResultNumTI: 1508,
          ResultNumSA: 3113,
          ResultNumTK: 3353,
          ResultNumNA: 677,
          ResultNumNI: 450,
          ResultPriceIB: 557,
          ResultPriceTO: 502,
          ResultPriceGU: 450,
          ResultPriceTI: 902,
          ResultPriceSA: 1806,
          ResultPriceTK: 2005,
          ResultPriceNA: 405,
          ResultPriceNI: 269,
          AppearNameIB: "",
          AppearNameTO: "",
          AppearNameGU: "",
          AppearNameTI: "",
          AppearNameSA: "",
          AppearNameTK: "",
          AppearNameNA: "",
          AppearNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "産地提携品",
          BrandNameNI: "ＮＢ",
          WinningGoodsNum: "1000",
          WinningGoodsPerPersonNum: "1000",
          PointExchangeOrderNum: "1000",
          PointExchangeEquivalentAmount: "1000",
          ExchangePoints: "1000",
          NvalOrderNum: "1000",
          NvalDiscountSupplyUnitPrice: "1000",
          CouponOrderNum: "1110",
          CouponDiscountSupplyUnitPrice: "1000",
        },
        {
          "Status": "4",
          "ClassCode": "01",
          "SmallClassCode": "020304",
          "GuideGoodsName": "メキシコバナナ（有機栽培）",
          "GuideStandardName": "５７０ｇ",
          "DealEnableCoopIB": "●",
          "DealEnableCoopTO": "●",
          "DealEnableCoopGU": "●",
          "DealEnableCoopTI": "●",
          "DealEnableCoopSA": "●",
          "DealEnableCoopTK": "●",
          "DealEnableCoopNA": "●",
          "DealEnableCoopNI": "●",
          "RelateMasterCode": "",
          "PCode": "P1010190",
          "ItemCodeIB": "1010190",
          "ItemCodeTO": "1010190",
          "ItemCodeGU": "1010190",
          "ItemCodeTI": "1010190",
          "ItemCodeSA": "1010190",
          "ItemCodeTK": "1010190",
          "ItemCodeNA": "1010190",
          "ItemCodeNI": "1010190",
          "JanCodeIB": "0400001923481",
          "JanCodeTO": "0400001923481",
          "JanCodeGU": "0400001923481",
          "JanCodeTI": "0400001923481",
          "JanCodeSA": "0400001923481",
          "JanCodeTK": "0400001923481",
          "JanCodeNA": "0400001923481",
          "JanCodeNI": "0400001923481",
          "GuideTempZoneName": "",
          "BuyerCode": "00100001",
          "PublishPageNumIB": 27,
          "PublishPageNumTO": 27,
          "PublishPageNumGU": 27,
          "PublishPageNumTI": 27,
          "PublishPageNumSA": 27,
          "PublishPageNumTK": 27,
          "PublishPageNumNA": 26,
          "PublishPageNumNI": 27,
          "PublishAmountLimitNumIB": 3.75,
          "PublishAmountLimitNumTO": 3.75,
          "PublishAmountLimitNumGU": 3.75,
          "PublishAmountLimitNumTI": 3.75,
          "PublishAmountLimitNumSA": 3.75,
          "PublishAmountLimitNumTK": 3.75,
          "PublishAmountLimitNumNA": 3.75,
          "PublishAmountLimitNumNI": 2,
          "OrderNumIB": "279   ",
          "OrderNumTO": "279   ",
          "OrderNumGU": "279   ",
          "OrderNumTI": "276   ",
          "OrderNumSA": "279   ",
          "OrderNumTK": "276   ",
          "OrderNumNA": "270   ",
          "OrderNumNI": "277   ",
          "ThisTimeSupplyPriceIB": 330,
          "ThisTimeSupplyPriceTO": 330,
          "ThisTimeSupplyPriceGU": 330,
          "ThisTimeSupplyPriceTI": 330,
          "ThisTimeSupplyPriceSA": 330,
          "ThisTimeSupplyPriceTK": 330,
          "ThisTimeSupplyPriceNA": 330,
          "ThisTimeSupplyPriceNI": 330,
          "SupplyPriceOffPercentIB": 17.1,
          "SupplyPriceOffPercentTO": 17.1,
          "SupplyPriceOffPercentGU": 17.1,
          "SupplyPriceOffPercentTI": 17.1,
          "SupplyPriceOffPercentSA": 17.1,
          "SupplyPriceOffPercentTK": 17.1,
          "SupplyPriceOffPercentNA": 17.1,
          "SupplyPriceOffPercentNI": 17.1,
          "SupplyPriceStandardIB": 398.0,
          "SupplyPriceStandardTO": 398.0,
          "SupplyPriceStandardGU": 398.0,
          "SupplyPriceStandardTI": 398.0,
          "SupplyPriceStandardSA": 398.0,
          "SupplyPriceStandardTK": 398.0,
          "SupplyPriceStandardNA": 398.0,
          "SupplyPriceStandardNI": 398.0,
          "ConsumeTaxDivName": "外税",
          "ConsumeTaxRate": 8,
          "ThisTimeCostPriceIB": 235.0,
          "ThisTimeCostPriceTO": 235.0,
          "ThisTimeCostPriceGU": 235.0,
          "ThisTimeCostPriceTI": 235.0,
          "ThisTimeCostPriceSA": 235.0,
          "ThisTimeCostPriceTK": 235.0,
          "ThisTimeCostPriceNA": 235.0,
          "ThisTimeCostPriceNI": 235.0,
          "CostPriceStandardIB": 235.0,
          "CostPriceStandardTO": 235.0,
          "CostPriceStandardGU": 235.0,
          "CostPriceStandardTI": 235.0,
          "CostPriceStandardSA": 235.0,
          "CostPriceStandardTK": 235.0,
          "CostPriceStandardNA": 235.0,
          "CostPriceStandardNI": 235.0,
          "BundlePriceIB": 1,
          "BundlePriceTO": 1,
          "BundlePriceGU": 1,
          "BundlePriceTI": 1,
          "BundlePriceSA": 1,
          "BundlePriceTK": 1,
          "BundlePriceNA": 1,
          "BundlePriceNI": 1,
          "GprIB": 28.8,
          "GprTO": 28.8,
          "GprGU": 28.8,
          "GprTI": 28.8,
          "GprSA": 28.8,
          "GprTK": 28.8,
          "GprNA": 28.8,
          "GprNI": 28.8,
          "GpIB": 80,
          "GpTO": 59,
          "GpGU": 76,
          "GpTI": 247,
          "GpSA": 209,
          "GpTK": 352,
          "GpNA": 105,
          "GpNI": 38,
          "GpALL": 1165,
          "FcmcFeeIB": 0.0,
          "FcmcFeeTO": 0.0,
          "FcmcFeeGU": 0.0,
          "FcmcFeeTI": 0.0,
          "FcmcFeeSA": 0.0,
          "FcmcFeeTK": 0.0,
          "FcmcFeeNA": 0.0,
          "FcmcFeeNI": 0.0,
          "PlanNumALL": 12260,
          "PlanNumIB": 840,
          "PlanNumTO": 620,
          "PlanNumGU": 800,
          "PlanNumTI": 2600,
          "PlanNumSA": 2200,
          "PlanNumTK": 3700,
          "PlanNumNA": 1100,
          "PlanNumNI": 400,
          "PlanPriceIB": 277,
          "PlanPriceTO": 205,
          "PlanPriceGU": 264,
          "PlanPriceTI": 858,
          "PlanPriceSA": 726,
          "PlanPriceTK": 1221,
          "PlanPriceNA": 363,
          "PlanPriceNI": 132,
          "PlanPriceALL": 4046,
          "NextGuideIB": "",
          "NextGuideTO": "",
          "NextGuideGU": "",
          "NextGuideTI": "",
          "NextGuideSA": "",
          "NextGuideTK": "",
          "NextGuideNA": "",
          "NextGuideNI": "",
          "PayeeClientNameIB": "コープネット農産",
          "PayeeClientNameTO": "コープネット農産",
          "PayeeClientNameGU": "コープネット農産",
          "PayeeClientNameTI": "コープネット農産",
          "PayeeClientNameSA": "コープネット農産",
          "PayeeClientNameTK": "コープネット農産",
          "PayeeClientNameNA": "コープネット農産",
          "PayeeClientNameNI": "コープネット農産",
          "OrderClientNameIB": "コープネット農産",
          "OrderClientNameTO": "コープネット農産",
          "OrderClientNameGU": "コープネット農産",
          "OrderClientNameTI": "コープネット農産",
          "OrderClientNameSA": "コープネット農産",
          "OrderClientNameTK": "コープネット農産",
          "OrderClientNameNA": "コープネット農産",
          "OrderClientNameNI": "コープネット農産",
          "PricePatternNameIB": "通常",
          "PricePatternNameTO": "通常",
          "PricePatternNameGU": "通常",
          "PricePatternNameTI": "通常",
          "PricePatternNameSA": "通常",
          "PricePatternNameTK": "通常",
          "PricePatternNameNA": "通常",
          "PricePatternNameNI": "通常",
          "OriginPlaceIB": "",
          "OriginPlaceTO": "",
          "OriginPlaceGU": "",
          "OriginPlaceTI": "",
          "OriginPlaceSA": "",
          "OriginPlaceTK": "",
          "OriginPlaceNA": "",
          "OriginPlaceNI": "",
          "PromotionNoIB": "",
          "PromotionNoTO": "",
          "PromotionNoGU": "",
          "PromotionNoTI": "",
          "PromotionNoSA": "",
          "PromotionNoTK": "",
          "PromotionNoNA": "",
          "PromotionNoNI": "",
          "ApprovedPriceIB": null,
          "ApprovedPriceTO": null,
          "ApprovedPriceGU": null,
          "ApprovedPriceTI": null,
          "ApprovedPriceSA": null,
          "ApprovedPriceTK": null,
          "ApprovedPriceNA": null,
          "ApprovedPriceNI": null,
          "BuyerComment": "",
          "MakerNameIB": "",
          "MakerNameTO": "",
          "MakerNameGU": "",
          "MakerNameTI": "",
          "MakerNameSA": "",
          "MakerNameTK": "",
          "MakerNameNA": "",
          "MakerNameNI": "",
          "NextGuideCheckIB": "0",
          "NextGuideCheckTO": "0",
          "NextGuideCheckGU": "0",
          "NextGuideCheckTI": "0",
          "NextGuideCheckSA": "0",
          "NextGuideCheckTK": "0",
          "NextGuideCheckNA": "0",
          "NextGuideCheckNI": "0",
          "MediumType": "001",
          "SetPromotionNoIB": "",
          "SetPromotionNoTO": "",
          "SetPromotionNoGU": "",
          "SetPromotionNoTI": "",
          "SetPromotionNoSA": "",
          "SetPromotionNoTK": "",
          "SetPromotionNoNA": "",
          "SetPromotionNoNI": "",
          "KikakuRenrakuStatus": "",
          "KikakuRenrakuStatusName": "",
          "KikakuRenrakuStatusBgColor": "",
          "WinningGoodsNum": null,
          "WinningGoodsPerPersonNum": null,
          "PointExchangeOrderNum": null,
          "PointExchangeEquivalentAmount": "",
          "ExchangePoints": "",
          "NvalOrderNum": "",
          "NvalDiscountSupplyUnitPrice": "",
          "CouponOrderNum": "",
          "CouponDiscountSupplyUnitPrice": "",
          "ResultGpIB": 76,
          "ResultGpTO": 57,
          "ResultGpGU": 65,
          "ResultGpTI": 253,
          "ResultGpSA": 186,
          "ResultGpTK": 339,
          "ResultGpNA": 96,
          "ResultGpNI": 40,
          "ResultNumIB": 802,
          "ResultNumTO": 605,
          "ResultNumGU": 686,
          "ResultNumTI": 2660,
          "ResultNumSA": 1960,
          "ResultNumTK": 3570,
          "ResultNumNA": 1009,
          "ResultNumNI": 416,
          "ResultPriceIB": 265,
          "ResultPriceTO": 200,
          "ResultPriceGU": 226,
          "ResultPriceTI": 878,
          "ResultPriceSA": 647,
          "ResultPriceTK": 1178,
          "ResultPriceNA": 333,
          "ResultPriceNI": 137,
          "AppearNameIB": "",
          "AppearNameTO": "",
          "AppearNameGU": "",
          "AppearNameTI": "",
          "AppearNameSA": "",
          "AppearNameTK": "",
          "AppearNameNA": "",
          "AppearNameNI": "",
          "BrandNameIB": "園地指定品",
          "BrandNameTO": "園地指定品",
          "BrandNameGU": "園地指定品",
          "BrandNameTI": "園地指定品",
          "BrandNameSA": "園地指定品",
          "BrandNameTK": "園地指定品",
          "BrandNameNA": "園地指定品",
          "BrandNameNI": "園地指定品"
        }
      ]
    }
  }
}

const getPlanNumListResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      GoodsNumCatalogId: 3705,
      GoodsNumMedia: 3705,
      GoodsNumList: 1,
      BudgetPrice: null,
      BudgetGp: null,
      PlanPrice: 8244828,
      PlanPriceBudgetRatio: null,
      PlanGp: 2393643,
      PlanGpBudgetRatio: null,
      PlanGpPreviousYearRatio: null,
      PlanGpr: 29.0,
      PlanGprPreviousYearRatio: null,
      PlanAvg: 369.0,
      PlanAvgYearRato: null
    }
  }
}

const getPlanTargetListResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      TotalNum: 2000,
      StartDispNum: 300,
      EndDispNum: 400,
      SelectTargetList: [
        {
          Status: "2",
          ClassCode: "01",
          MiddleClassCode: "0303",
          SmallClassCode: "030309",
          GuideGoodsName: "モロヘイヤ",
          GuideStandardName: "９０ｇ",
          PCode: "P0001414",
          JanCodeIB: "0400000000312",
          JanCodeTO: "0400000000312",
          JanCodeGU: "0400000000312",
          JanCodeTI: "0400000000312",
          JanCodeSA: "0400000000312",
          JanCodeTK: "0400000000312",
          JanCodeNA: "0400000000312",
          JanCodeNI: "0400000000312",
          JustBeforeCatalogId: "",
          JustBeforeSupplyPriceIB: null,
          JustBeforeSupplyPriceTO: null,
          JustBeforeSupplyPriceGU: null,
          JustBeforeSupplyPriceTI: null,
          JustBeforeSupplyPriceSA: null,
          JustBeforeSupplyPriceTK: null,
          JustBeforeSupplyPriceNA: null,
          JustBeforeSupplyPriceNI: null,
          JustBeforeCostPriceIB: null,
          JustBeforeCostPriceTO: null,
          JustBeforeCostPriceGU: null,
          JustBeforeCostPriceTI: null,
          JustBeforeCostPriceSA: null,
          JustBeforeCostPriceTK: null,
          JustBeforeCostPriceNA: null,
          JustBeforeCostPriceNI: null,
          JustBeforeGprALL: null,
          JustBeforeGprIB: null,
          JustBeforeGprTO: null,
          JustBeforeGprGU: null,
          JustBeforeGprTI: null,
          JustBeforeGprSA: null,
          JustBeforeGprTK: null,
          JustBeforeGprNA: null,
          JustBeforeGprNI: null,
          JustBeforeResultsNumALL: null,
          JustBeforeResultsNumIB: null,
          JustBeforeResultsNumTO: null,
          JustBeforeResultsNumGU: null,
          JustBeforeResultsNumTI: null,
          JustBeforeResultsNumSA: null,
          JustBeforeResultsNumTK: null,
          JustBeforeResultsNumNA: null,
          JustBeforeResultsNumNI: null,
          AvgResultPriceALL: 1445307,
          SupplyPriceStandardIB: 168,
          SupplyPriceStandardTO: 168,
          SupplyPriceStandardGU: 168,
          SupplyPriceStandardTI: 168,
          SupplyPriceStandardSA: 168,
          SupplyPriceStandardTK: 168,
          SupplyPriceStandardNA: 168,
          SupplyPriceStandardNI: 168,
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          MaxResultNumALL: 11614,
          AvgResultNumALL: 9598,
          MinResultNumALL: 7496,
          AssortTempName: "青果",
          RelateMasterCode: "",
          JustBeforePiIB: 0.0,
          JustBeforePiTO: 0.0,
          JustBeforePiGU: 0.0,
          JustBeforePiTI: 0.0,
          JustBeforePiSA: 0.0,
          JustBeforePiTK: 0.0,
          JustBeforePiNA: 0.0,
          JustBeforePiNI: 0.0,
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "ＮＢ",
          BrandNameNI: "ＮＢ",
          NextCatalog: "20230702",
          EbaseSpecCodeIB: "",
          EbaseSpecCodeTO: "",
          EbaseSpecCodeGU: "",
          EbaseSpecCodeTI: "",
          EbaseSpecCodeSA: "",
          EbaseSpecCodeTK: "",
          EbaseSpecCodeNA: "",
          EbaseSpecCodeNI: "",
          CostPriceStandardIB: 113,
          CostPriceStandardTO: 113,
          CostPriceStandardGU: 113,
          CostPriceStandardTI: 113,
          CostPriceStandardSA: 113,
          CostPriceStandardTK: 113,
          CostPriceStandardNA: 113,
          CostPriceStandardNI: 113,
          FixContainNumIB: 1,
          FixContainNumTO: 1,
          FixContainNumGU: 1,
          FixContainNumTI: 1,
          FixContainNumSA: 1,
          FixContainNumTK: 1,
          FixContainNumNA: 1,
          FixContainNumNI: 1,
          BuyerCode: "00100001",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          MediumType: "001",
          SellAreaCode: "20",
          AdmitStatus: "2",
          PlanClassCode: "01",
          PlanMiddleClassCode: "0303",
          PlanSmallClassCode: "030309",
          JustBeforeResultsPriceALL: null,
          JustBeforeResultsPriceIB: null,
          JustBeforeResultsPriceTO: null,
          JustBeforeResultsPriceGU: null,
          JustBeforeResultsPriceTI: null,
          JustBeforeResultsPriceSA: null,
          JustBeforeResultsPriceTK: null,
          JustBeforeResultsPriceNA: null,
          JustBeforeResultsPriceNI: null
        },
        {
          Status: "3",
          ClassCode: "01",
          MiddleClassCode: "0303",
          SmallClassCode: "030309",
          GuideGoodsName: "モロヘイヤ",
          GuideStandardName: "９０ｇ",
          PCode: "P0001414",
          JanCodeIB: "0400000000312",
          JanCodeTO: "0400000000312",
          JanCodeGU: "0400000000312",
          JanCodeTI: "0400000000312",
          JanCodeSA: "0400000000312",
          JanCodeTK: "0400000000312",
          JanCodeNA: "0400000000312",
          JanCodeNI: "0400000000312",
          JustBeforeCatalogId: "",
          JustBeforeSupplyPriceIB: null,
          JustBeforeSupplyPriceTO: null,
          JustBeforeSupplyPriceGU: null,
          JustBeforeSupplyPriceTI: null,
          JustBeforeSupplyPriceSA: null,
          JustBeforeSupplyPriceTK: null,
          JustBeforeSupplyPriceNA: null,
          JustBeforeSupplyPriceNI: null,
          JustBeforeCostPriceIB: null,
          JustBeforeCostPriceTO: null,
          JustBeforeCostPriceGU: null,
          JustBeforeCostPriceTI: null,
          JustBeforeCostPriceSA: null,
          JustBeforeCostPriceTK: null,
          JustBeforeCostPriceNA: null,
          JustBeforeCostPriceNI: null,
          JustBeforeGprALL: null,
          JustBeforeGprIB: null,
          JustBeforeGprTO: null,
          JustBeforeGprGU: null,
          JustBeforeGprTI: null,
          JustBeforeGprSA: null,
          JustBeforeGprTK: null,
          JustBeforeGprNA: null,
          JustBeforeGprNI: null,
          JustBeforeResultsNumALL: null,
          JustBeforeResultsNumIB: null,
          JustBeforeResultsNumTO: null,
          JustBeforeResultsNumGU: null,
          JustBeforeResultsNumTI: null,
          JustBeforeResultsNumSA: null,
          JustBeforeResultsNumTK: null,
          JustBeforeResultsNumNA: null,
          JustBeforeResultsNumNI: null,
          AvgResultPriceALL: 1445307,
          SupplyPriceStandardIB: 168,
          SupplyPriceStandardTO: 168,
          SupplyPriceStandardGU: 168,
          SupplyPriceStandardTI: 168,
          SupplyPriceStandardSA: 168,
          SupplyPriceStandardTK: 168,
          SupplyPriceStandardNA: 168,
          SupplyPriceStandardNI: 168,
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          MaxResultNumALL: 11614,
          AvgResultNumALL: 9598,
          MinResultNumALL: 7496,
          AssortTempName: "青果",
          RelateMasterCode: "",
          JustBeforePiIB: 0.0,
          JustBeforePiTO: 0.0,
          JustBeforePiGU: 0.0,
          JustBeforePiTI: 0.0,
          JustBeforePiSA: 0.0,
          JustBeforePiTK: 0.0,
          JustBeforePiNA: 0.0,
          JustBeforePiNI: 0.0,
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "ＮＢ",
          BrandNameNI: "ＮＢ",
          NextCatalog: "20230702",
          EbaseSpecCodeIB: "",
          EbaseSpecCodeTO: "",
          EbaseSpecCodeGU: "",
          EbaseSpecCodeTI: "",
          EbaseSpecCodeSA: "",
          EbaseSpecCodeTK: "",
          EbaseSpecCodeNA: "",
          EbaseSpecCodeNI: "",
          CostPriceStandardIB: 113,
          CostPriceStandardTO: 113,
          CostPriceStandardGU: 113,
          CostPriceStandardTI: 113,
          CostPriceStandardSA: 113,
          CostPriceStandardTK: 113,
          CostPriceStandardNA: 113,
          CostPriceStandardNI: 113,
          FixContainNumIB: 1,
          FixContainNumTO: 1,
          FixContainNumGU: 1,
          FixContainNumTI: 1,
          FixContainNumSA: 1,
          FixContainNumTK: 1,
          FixContainNumNA: 1,
          FixContainNumNI: 1,
          BuyerCode: "00100001",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          MediumType: "001",
          SellAreaCode: "20",
          AdmitStatus: "2",
          PlanClassCode: "01",
          PlanMiddleClassCode: "0303",
          PlanSmallClassCode: "030309",
          JustBeforeResultsPriceALL: null,
          JustBeforeResultsPriceIB: null,
          JustBeforeResultsPriceTO: null,
          JustBeforeResultsPriceGU: null,
          JustBeforeResultsPriceTI: null,
          JustBeforeResultsPriceSA: null,
          JustBeforeResultsPriceTK: null,
          JustBeforeResultsPriceNA: null,
          JustBeforeResultsPriceNI: null
        },
        {
          Status: "4",
          ClassCode: "01",
          MiddleClassCode: "0303",
          SmallClassCode: "030309",
          GuideGoodsName: "モロヘイヤ",
          GuideStandardName: "９０ｇ",
          PCode: "P0001414",
          JanCodeIB: "0400000000312",
          JanCodeTO: "0400000000312",
          JanCodeGU: "0400000000312",
          JanCodeTI: "0400000000312",
          JanCodeSA: "0400000000312",
          JanCodeTK: "0400000000312",
          JanCodeNA: "0400000000312",
          JanCodeNI: "0400000000312",
          JustBeforeCatalogId: "",
          JustBeforeSupplyPriceIB: null,
          JustBeforeSupplyPriceTO: null,
          JustBeforeSupplyPriceGU: null,
          JustBeforeSupplyPriceTI: null,
          JustBeforeSupplyPriceSA: null,
          JustBeforeSupplyPriceTK: null,
          JustBeforeSupplyPriceNA: null,
          JustBeforeSupplyPriceNI: null,
          JustBeforeCostPriceIB: null,
          JustBeforeCostPriceTO: null,
          JustBeforeCostPriceGU: null,
          JustBeforeCostPriceTI: null,
          JustBeforeCostPriceSA: null,
          JustBeforeCostPriceTK: null,
          JustBeforeCostPriceNA: null,
          JustBeforeCostPriceNI: null,
          JustBeforeGprALL: null,
          JustBeforeGprIB: null,
          JustBeforeGprTO: null,
          JustBeforeGprGU: null,
          JustBeforeGprTI: null,
          JustBeforeGprSA: null,
          JustBeforeGprTK: null,
          JustBeforeGprNA: null,
          JustBeforeGprNI: null,
          JustBeforeResultsNumALL: null,
          JustBeforeResultsNumIB: null,
          JustBeforeResultsNumTO: null,
          JustBeforeResultsNumGU: null,
          JustBeforeResultsNumTI: null,
          JustBeforeResultsNumSA: null,
          JustBeforeResultsNumTK: null,
          JustBeforeResultsNumNA: null,
          JustBeforeResultsNumNI: null,
          AvgResultPriceALL: 1445307,
          SupplyPriceStandardIB: 168,
          SupplyPriceStandardTO: 168,
          SupplyPriceStandardGU: 168,
          SupplyPriceStandardTI: 168,
          SupplyPriceStandardSA: 168,
          SupplyPriceStandardTK: 168,
          SupplyPriceStandardNA: 168,
          SupplyPriceStandardNI: 168,
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          MaxResultNumALL: 11614,
          AvgResultNumALL: 9598,
          MinResultNumALL: 7496,
          AssortTempName: "青果",
          RelateMasterCode: "",
          JustBeforePiIB: 0.0,
          JustBeforePiTO: 0.0,
          JustBeforePiGU: 0.0,
          JustBeforePiTI: 0.0,
          JustBeforePiSA: 0.0,
          JustBeforePiTK: 0.0,
          JustBeforePiNA: 0.0,
          JustBeforePiNI: 0.0,
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "ＮＢ",
          BrandNameNI: "ＮＢ",
          NextCatalog: "20230702",
          EbaseSpecCodeIB: "",
          EbaseSpecCodeTO: "",
          EbaseSpecCodeGU: "",
          EbaseSpecCodeTI: "",
          EbaseSpecCodeSA: "",
          EbaseSpecCodeTK: "",
          EbaseSpecCodeNA: "",
          EbaseSpecCodeNI: "",
          CostPriceStandardIB: 113,
          CostPriceStandardTO: 113,
          CostPriceStandardGU: 113,
          CostPriceStandardTI: 113,
          CostPriceStandardSA: 113,
          CostPriceStandardTK: 113,
          CostPriceStandardNA: 113,
          CostPriceStandardNI: 113,
          FixContainNumIB: 1,
          FixContainNumTO: 1,
          FixContainNumGU: 1,
          FixContainNumTI: 1,
          FixContainNumSA: 1,
          FixContainNumTK: 1,
          FixContainNumNA: 1,
          FixContainNumNI: 1,
          BuyerCode: "00100001",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          MediumType: "001",
          SellAreaCode: "20",
          AdmitStatus: "2",
          PlanClassCode: "01",
          PlanMiddleClassCode: "0303",
          PlanSmallClassCode: "030309",
          JustBeforeResultsPriceALL: null,
          JustBeforeResultsPriceIB: null,
          JustBeforeResultsPriceTO: null,
          JustBeforeResultsPriceGU: null,
          JustBeforeResultsPriceTI: null,
          JustBeforeResultsPriceSA: null,
          JustBeforeResultsPriceTK: null,
          JustBeforeResultsPriceNA: null,
          JustBeforeResultsPriceNI: null
        },
        {
          Status: "9",
          ClassCode: "01",
          MiddleClassCode: "0303",
          SmallClassCode: "030309",
          GuideGoodsName: "モロヘイヤ",
          GuideStandardName: "９０ｇ",
          PCode: "P0001414",
          JanCodeIB: "0400000000312",
          JanCodeTO: "0400000000312",
          JanCodeGU: "0400000000312",
          JanCodeTI: "0400000000312",
          JanCodeSA: "0400000000312",
          JanCodeTK: "0400000000312",
          JanCodeNA: "0400000000312",
          JanCodeNI: "0400000000312",
          JustBeforeCatalogId: "",
          JustBeforeSupplyPriceIB: null,
          JustBeforeSupplyPriceTO: null,
          JustBeforeSupplyPriceGU: null,
          JustBeforeSupplyPriceTI: null,
          JustBeforeSupplyPriceSA: null,
          JustBeforeSupplyPriceTK: null,
          JustBeforeSupplyPriceNA: null,
          JustBeforeSupplyPriceNI: null,
          JustBeforeCostPriceIB: null,
          JustBeforeCostPriceTO: null,
          JustBeforeCostPriceGU: null,
          JustBeforeCostPriceTI: null,
          JustBeforeCostPriceSA: null,
          JustBeforeCostPriceTK: null,
          JustBeforeCostPriceNA: null,
          JustBeforeCostPriceNI: null,
          JustBeforeGprALL: null,
          JustBeforeGprIB: null,
          JustBeforeGprTO: null,
          JustBeforeGprGU: null,
          JustBeforeGprTI: null,
          JustBeforeGprSA: null,
          JustBeforeGprTK: null,
          JustBeforeGprNA: null,
          JustBeforeGprNI: null,
          JustBeforeResultsNumALL: null,
          JustBeforeResultsNumIB: null,
          JustBeforeResultsNumTO: null,
          JustBeforeResultsNumGU: null,
          JustBeforeResultsNumTI: null,
          JustBeforeResultsNumSA: null,
          JustBeforeResultsNumTK: null,
          JustBeforeResultsNumNA: null,
          JustBeforeResultsNumNI: null,
          AvgResultPriceALL: 1445307,
          SupplyPriceStandardIB: 168,
          SupplyPriceStandardTO: 168,
          SupplyPriceStandardGU: 168,
          SupplyPriceStandardTI: 168,
          SupplyPriceStandardSA: 168,
          SupplyPriceStandardTK: 168,
          SupplyPriceStandardNA: 168,
          SupplyPriceStandardNI: 168,
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          MaxResultNumALL: 11614,
          AvgResultNumALL: 9598,
          MinResultNumALL: 7496,
          AssortTempName: "青果",
          RelateMasterCode: "",
          JustBeforePiIB: 0.0,
          JustBeforePiTO: 0.0,
          JustBeforePiGU: 0.0,
          JustBeforePiTI: 0.0,
          JustBeforePiSA: 0.0,
          JustBeforePiTK: 0.0,
          JustBeforePiNA: 0.0,
          JustBeforePiNI: 0.0,
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "ＮＢ",
          BrandNameNI: "ＮＢ",
          NextCatalog: "20230702",
          EbaseSpecCodeIB: "",
          EbaseSpecCodeTO: "",
          EbaseSpecCodeGU: "",
          EbaseSpecCodeTI: "",
          EbaseSpecCodeSA: "",
          EbaseSpecCodeTK: "",
          EbaseSpecCodeNA: "",
          EbaseSpecCodeNI: "",
          CostPriceStandardIB: 113,
          CostPriceStandardTO: 113,
          CostPriceStandardGU: 113,
          CostPriceStandardTI: 113,
          CostPriceStandardSA: 113,
          CostPriceStandardTK: 113,
          CostPriceStandardNA: 113,
          CostPriceStandardNI: 113,
          FixContainNumIB: 1,
          FixContainNumTO: 1,
          FixContainNumGU: 1,
          FixContainNumTI: 1,
          FixContainNumSA: 1,
          FixContainNumTK: 1,
          FixContainNumNA: 1,
          FixContainNumNI: 1,
          BuyerCode: "00100001",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          MediumType: "001",
          SellAreaCode: "20",
          AdmitStatus: "2",
          PlanClassCode: "01",
          PlanMiddleClassCode: "0303",
          PlanSmallClassCode: "030309",
          JustBeforeResultsPriceALL: null,
          JustBeforeResultsPriceIB: null,
          JustBeforeResultsPriceTO: null,
          JustBeforeResultsPriceGU: null,
          JustBeforeResultsPriceTI: null,
          JustBeforeResultsPriceSA: null,
          JustBeforeResultsPriceTK: null,
          JustBeforeResultsPriceNA: null,
          JustBeforeResultsPriceNI: null
        },
        {
          Status: "1",
          ClassCode: "01",
          MiddleClassCode: "0303",
          SmallClassCode: "030309",
          GuideGoodsName: "モロヘイヤ",
          GuideStandardName: "９０ｇ",
          PCode: "P0001414",
          JanCodeIB: "0400000000312",
          JanCodeTO: "0400000000312",
          JanCodeGU: "0400000000312",
          JanCodeTI: "0400000000312",
          JanCodeSA: "0400000000312",
          JanCodeTK: "0400000000312",
          JanCodeNA: "0400000000312",
          JanCodeNI: "0400000000312",
          JustBeforeCatalogId: "",
          JustBeforeSupplyPriceIB: null,
          JustBeforeSupplyPriceTO: null,
          JustBeforeSupplyPriceGU: null,
          JustBeforeSupplyPriceTI: null,
          JustBeforeSupplyPriceSA: null,
          JustBeforeSupplyPriceTK: null,
          JustBeforeSupplyPriceNA: null,
          JustBeforeSupplyPriceNI: null,
          JustBeforeCostPriceIB: null,
          JustBeforeCostPriceTO: null,
          JustBeforeCostPriceGU: null,
          JustBeforeCostPriceTI: null,
          JustBeforeCostPriceSA: null,
          JustBeforeCostPriceTK: null,
          JustBeforeCostPriceNA: null,
          JustBeforeCostPriceNI: null,
          JustBeforeGprALL: null,
          JustBeforeGprIB: null,
          JustBeforeGprTO: null,
          JustBeforeGprGU: null,
          JustBeforeGprTI: null,
          JustBeforeGprSA: null,
          JustBeforeGprTK: null,
          JustBeforeGprNA: null,
          JustBeforeGprNI: null,
          JustBeforeResultsNumALL: null,
          JustBeforeResultsNumIB: null,
          JustBeforeResultsNumTO: null,
          JustBeforeResultsNumGU: null,
          JustBeforeResultsNumTI: null,
          JustBeforeResultsNumSA: null,
          JustBeforeResultsNumTK: null,
          JustBeforeResultsNumNA: null,
          JustBeforeResultsNumNI: null,
          AvgResultPriceALL: 1445307,
          SupplyPriceStandardIB: 168,
          SupplyPriceStandardTO: 168,
          SupplyPriceStandardGU: 168,
          SupplyPriceStandardTI: 168,
          SupplyPriceStandardSA: 168,
          SupplyPriceStandardTK: 168,
          SupplyPriceStandardNA: 168,
          SupplyPriceStandardNI: 168,
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          MaxResultNumALL: 11614,
          AvgResultNumALL: 9598,
          MinResultNumALL: 7496,
          AssortTempName: "青果",
          RelateMasterCode: "",
          JustBeforePiIB: 0.0,
          JustBeforePiTO: 0.0,
          JustBeforePiGU: 0.0,
          JustBeforePiTI: 0.0,
          JustBeforePiSA: 0.0,
          JustBeforePiTK: 0.0,
          JustBeforePiNA: 0.0,
          JustBeforePiNI: 0.0,
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "ＮＢ",
          BrandNameNI: "ＮＢ",
          NextCatalog: "20230702",
          EbaseSpecCodeIB: "",
          EbaseSpecCodeTO: "",
          EbaseSpecCodeGU: "",
          EbaseSpecCodeTI: "",
          EbaseSpecCodeSA: "",
          EbaseSpecCodeTK: "",
          EbaseSpecCodeNA: "",
          EbaseSpecCodeNI: "",
          CostPriceStandardIB: 113,
          CostPriceStandardTO: 113,
          CostPriceStandardGU: 113,
          CostPriceStandardTI: 113,
          CostPriceStandardSA: 113,
          CostPriceStandardTK: 113,
          CostPriceStandardNA: 113,
          CostPriceStandardNI: 113,
          FixContainNumIB: 1,
          FixContainNumTO: 1,
          FixContainNumGU: 1,
          FixContainNumTI: 1,
          FixContainNumSA: 1,
          FixContainNumTK: 1,
          FixContainNumNA: 1,
          FixContainNumNI: 1,
          BuyerCode: "00100001",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          MediumType: "001",
          SellAreaCode: "20",
          AdmitStatus: "2",
          PlanClassCode: "01",
          PlanMiddleClassCode: "0303",
          PlanSmallClassCode: "030309",
          JustBeforeResultsPriceALL: null,
          JustBeforeResultsPriceIB: null,
          JustBeforeResultsPriceTO: null,
          JustBeforeResultsPriceGU: null,
          JustBeforeResultsPriceTI: null,
          JustBeforeResultsPriceSA: null,
          JustBeforeResultsPriceTK: null,
          JustBeforeResultsPriceNA: null,
          JustBeforeResultsPriceNI: null
        },
        {
          Status: "0",
          ClassCode: "01",
          MiddleClassCode: "0303",
          SmallClassCode: "030309",
          GuideGoodsName: "モロヘイヤ",
          GuideStandardName: "９０ｇ",
          PCode: "P0001414",
          JanCodeIB: "0400000000312",
          JanCodeTO: "0400000000312",
          JanCodeGU: "0400000000312",
          JanCodeTI: "0400000000312",
          JanCodeSA: "0400000000312",
          JanCodeTK: "0400000000312",
          JanCodeNA: "0400000000312",
          JanCodeNI: "0400000000312",
          JustBeforeCatalogId: "",
          JustBeforeSupplyPriceIB: null,
          JustBeforeSupplyPriceTO: null,
          JustBeforeSupplyPriceGU: null,
          JustBeforeSupplyPriceTI: null,
          JustBeforeSupplyPriceSA: null,
          JustBeforeSupplyPriceTK: null,
          JustBeforeSupplyPriceNA: null,
          JustBeforeSupplyPriceNI: null,
          JustBeforeCostPriceIB: null,
          JustBeforeCostPriceTO: null,
          JustBeforeCostPriceGU: null,
          JustBeforeCostPriceTI: null,
          JustBeforeCostPriceSA: null,
          JustBeforeCostPriceTK: null,
          JustBeforeCostPriceNA: null,
          JustBeforeCostPriceNI: null,
          JustBeforeGprALL: null,
          JustBeforeGprIB: null,
          JustBeforeGprTO: null,
          JustBeforeGprGU: null,
          JustBeforeGprTI: null,
          JustBeforeGprSA: null,
          JustBeforeGprTK: null,
          JustBeforeGprNA: null,
          JustBeforeGprNI: null,
          JustBeforeResultsNumALL: null,
          JustBeforeResultsNumIB: null,
          JustBeforeResultsNumTO: null,
          JustBeforeResultsNumGU: null,
          JustBeforeResultsNumTI: null,
          JustBeforeResultsNumSA: null,
          JustBeforeResultsNumTK: null,
          JustBeforeResultsNumNA: null,
          JustBeforeResultsNumNI: null,
          AvgResultPriceALL: 1445307,
          SupplyPriceStandardIB: 168,
          SupplyPriceStandardTO: 168,
          SupplyPriceStandardGU: 168,
          SupplyPriceStandardTI: 168,
          SupplyPriceStandardSA: 168,
          SupplyPriceStandardTK: 168,
          SupplyPriceStandardNA: 168,
          SupplyPriceStandardNI: 168,
          PayeeClientNameIB: "コープネット農産",
          PayeeClientNameTO: "コープネット農産",
          PayeeClientNameGU: "コープネット農産",
          PayeeClientNameTI: "コープネット農産",
          PayeeClientNameSA: "コープネット農産",
          PayeeClientNameTK: "コープネット農産",
          PayeeClientNameNA: "コープネット農産",
          PayeeClientNameNI: "コープネット農産",
          OrderClientNameIB: "コープネット農産",
          OrderClientNameTO: "コープネット農産",
          OrderClientNameGU: "コープネット農産",
          OrderClientNameTI: "コープネット農産",
          OrderClientNameSA: "コープネット農産",
          OrderClientNameTK: "コープネット農産",
          OrderClientNameNA: "コープネット農産",
          OrderClientNameNI: "コープネット農産",
          MaxResultNumALL: 11614,
          AvgResultNumALL: 9598,
          MinResultNumALL: 7496,
          AssortTempName: "青果",
          RelateMasterCode: "",
          JustBeforePiIB: 0.0,
          JustBeforePiTO: 0.0,
          JustBeforePiGU: 0.0,
          JustBeforePiTI: 0.0,
          JustBeforePiSA: 0.0,
          JustBeforePiTK: 0.0,
          JustBeforePiNA: 0.0,
          JustBeforePiNI: 0.0,
          OriginPlaceIB: "",
          OriginPlaceTO: "",
          OriginPlaceGU: "",
          OriginPlaceTI: "",
          OriginPlaceSA: "",
          OriginPlaceTK: "",
          OriginPlaceNA: "",
          OriginPlaceNI: "",
          MakerNameIB: "",
          MakerNameTO: "",
          MakerNameGU: "",
          MakerNameTI: "",
          MakerNameSA: "",
          MakerNameTK: "",
          MakerNameNA: "",
          MakerNameNI: "",
          BrandNameIB: "ＮＢ",
          BrandNameTO: "ＮＢ",
          BrandNameGU: "ＮＢ",
          BrandNameTI: "ＮＢ",
          BrandNameSA: "ＮＢ",
          BrandNameTK: "ＮＢ",
          BrandNameNA: "ＮＢ",
          BrandNameNI: "ＮＢ",
          NextCatalog: "20230702",
          EbaseSpecCodeIB: "",
          EbaseSpecCodeTO: "",
          EbaseSpecCodeGU: "",
          EbaseSpecCodeTI: "",
          EbaseSpecCodeSA: "",
          EbaseSpecCodeTK: "",
          EbaseSpecCodeNA: "",
          EbaseSpecCodeNI: "",
          CostPriceStandardIB: 113,
          CostPriceStandardTO: 113,
          CostPriceStandardGU: 113,
          CostPriceStandardTI: 113,
          CostPriceStandardSA: 113,
          CostPriceStandardTK: 113,
          CostPriceStandardNA: 113,
          CostPriceStandardNI: 113,
          FixContainNumIB: 1,
          FixContainNumTO: 1,
          FixContainNumGU: 1,
          FixContainNumTI: 1,
          FixContainNumSA: 1,
          FixContainNumTK: 1,
          FixContainNumNA: 1,
          FixContainNumNI: 1,
          BuyerCode: "00100001",
          DealEnableCoopIB: "●",
          DealEnableCoopTO: "●",
          DealEnableCoopGU: "●",
          DealEnableCoopTI: "●",
          DealEnableCoopSA: "●",
          DealEnableCoopTK: "●",
          DealEnableCoopNA: "●",
          DealEnableCoopNI: "●",
          FcmcFeeIB: 0,
          FcmcFeeTO: 0,
          FcmcFeeGU: 0,
          FcmcFeeTI: 0,
          FcmcFeeSA: 0,
          FcmcFeeTK: 0,
          FcmcFeeNA: 0,
          FcmcFeeNI: 0,
          MediumType: "001",
          SellAreaCode: "20",
          AdmitStatus: "2",
          PlanClassCode: "01",
          PlanMiddleClassCode: "0303",
          PlanSmallClassCode: "030309",
          JustBeforeResultsPriceALL: null,
          JustBeforeResultsPriceIB: null,
          JustBeforeResultsPriceTO: null,
          JustBeforeResultsPriceGU: null,
          JustBeforeResultsPriceTI: null,
          JustBeforeResultsPriceSA: null,
          JustBeforeResultsPriceTK: null,
          JustBeforeResultsPriceNA: null,
          JustBeforeResultsPriceNI: null
        }
      ]
    }
  }
}

const checkDeletePlanResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        PCode: "P1010190",
        MessageID: "Q0113",
        Parameter1: "P1010190",
        Parameter2: "メキシコバナナ（有機栽培）",
        Parameter3: "",
        Parameter4: "",
        Parameter5: ""
      }
    ]

  }
}

const deletePlanResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      PCodeList: {
        PCode: [
          "P0067504"
        ],
      },
      CheckErrorList: [
        {
          MessageID: "",
          Parameter1: "",
          Parameter2: "",
          Parameter3: "",
          Parameter4: "",
          Parameter5: "",
        }
      ],
      OrderCodeSpecifyDeletePlanList: [
        {
          PCode: "P1010190",
          GuideGoodsName: "メキシコバナナ（有機栽培）",
          GuideStandardName: "５７０ｇ"
        },
      ],
      OrderCodeSpecifyDeletePlanViewFlg: 1
    },
  }
}

const checkRegistPlanResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      // {
      //   PCode: "P2644099",
      //   LockErrFlg: "1",
      //   MessageID: "Q0142",
      //   Parameter1: "P2644099",
      //   Parameter2: "[a]",
      //   ErrorID: "2"
      // }
    ]
  }
}

const registPlanResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      ClassCode: "",
      MiddleClassCode: "",
      SmallClassCode: "",
      PCodeList: {
        PCode: [
        ]
      },
      CheckErrorList: [
        {
          MessageID: "E0138",
          Parameter1: "P0211257",
          Parameter2: "塩秋鮭（北海道産・中辛口）",
          Parameter3: "",
          Parameter4: "",
          Parameter5: ""
        }
      ]
    }
  }
}

const getSetPlanPromotionGoodsInfoResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "PromotionNo": "S74371",
        "PromotionName": "",
        "PromotionDiv": "S",
        "OrderCode": "2025300",
        "MediumType": "004",
        "PCode": "P2622721",
        "GuideGoodsName": "離乳食スタートセット",
        "GuideStandardName": "（３品＋ブック）",
        "ConsumeTaxDiv": "0",
        "ConsumeTaxRate": "8",
        "SetDelivGoodsName": "離乳食スタートセット",
        "SetDelivGoodsNameKana": "ﾘﾆﾕｳｼﾖｸｽﾀｰﾄｾﾂﾄ",
        "SetDelivStandardName": "（３品＋ブック）",
        "SetDelivStandardNameKana": "(3ﾋﾝ+ﾌﾞﾂｸ)",
        "DeliveryGoodsNameKanji": "離乳食スタートセット",
        "DeliveryGoodsNameKana": "ﾘﾆﾕｳｼﾖｸｽﾀｰﾄｾﾂﾄ",
        "DeliveryStandardNameKanji": "（３品＋ブック）",
        "DeliveryStandardNameKana": "(3ﾋﾝ+ﾌﾞﾂｸ)",
        "SetPlanDiv": "1",
        "SetPlanDivName": "1：親",
        "AcceptDiv": "1",
        "AcceptDivName": "1：可能",
        "SupplyDiv": "0",
        "SupplyDivName": "0：不可",
        "SingleOrderFlag": "1",
        "SingleOrderFlagName": "1：可能",
        "HandlingFlgIB": "1",
        "ThisTimeSupplyPriceIB": 946,
        "ThisTimeCostPriceIB": 946,
        "PromotionFlgIB": "1",
        "ApprovedNumIB": 1,
        "ApprovedPriceIB": 946,
        "DeliveryLeadTimeTypeIB": "01",
        "DeliveryLeadTimeTypeNameIB": "01：翌週",
        "HandlingFlgTO": "1",
        "ThisTimeSupplyPriceTO": 946,
        "ThisTimeCostPriceTO": 946,
        "PromotionFlgTO": "1",
        "ApprovedNumTO": 1,
        "ApprovedPriceTO": 946,
        "DeliveryLeadTimeTypeTO": "01",
        "DeliveryLeadTimeTypeNameTO": "01：翌週",
        "HandlingFlgGU": "1",
        "ThisTimeSupplyPriceGU": 946,
        "ThisTimeCostPriceGU": 946,
        "PromotionFlgGU": "1",
        "ApprovedNumGU": 1,
        "ApprovedPriceGU": 946,
        "DeliveryLeadTimeTypeGU": "01",
        "DeliveryLeadTimeTypeNameGU": "01：翌週",
        "HandlingFlgTI": "1",
        "ThisTimeSupplyPriceTI": 946,
        "ThisTimeCostPriceTI": 946,
        "PromotionFlgTI": "1",
        "ApprovedNumTI": 1,
        "ApprovedPriceTI": 946,
        "DeliveryLeadTimeTypeTI": "01",
        "DeliveryLeadTimeTypeNameTI": "01：翌週",
        "HandlingFlgSA": "1",
        "ThisTimeSupplyPriceSA": 946,
        "ThisTimeCostPriceSA": 946,
        "PromotionFlgSA": "1",
        "ApprovedNumSA": 1,
        "ApprovedPriceSA": 946,
        "DeliveryLeadTimeTypeSA": "01",
        "DeliveryLeadTimeTypeNameSA": "01：翌週",
        "HandlingFlgTK": "1",
        "ThisTimeSupplyPriceTK": 946,
        "ThisTimeCostPriceTK": 946,
        "PromotionFlgTK": "1",
        "ApprovedNumTK": 1,
        "ApprovedPriceTK": 946,
        "DeliveryLeadTimeTypeTK": "01",
        "DeliveryLeadTimeTypeNameTK": "01：翌週",
        "HandlingFlgNA": "1",
        "ThisTimeSupplyPriceNA": 946,
        "ThisTimeCostPriceNA": 946,
        "PromotionFlgNA": "1",
        "ApprovedNumNA": 1,
        "ApprovedPriceNA": 946,
        "DeliveryLeadTimeTypeNA": "01",
        "DeliveryLeadTimeTypeNameNA": "01：翌週",
        "HandlingFlgNI": "1",
        "ThisTimeSupplyPriceNI": 946,
        "ThisTimeCostPriceNI": 946,
        "PromotionFlgNI": "1",
        "ApprovedNumNI": 1,
        "ApprovedPriceNI": 946,
        "DeliveryLeadTimeTypeNI": "01",
        "DeliveryLeadTimeTypeNameNI": "01：翌週",
        "HandlingFlgKU": "0",
        "ThisTimeSupplyPriceKU": 0,
        "ThisTimeCostPriceKU": 0,
        "PromotionFlgKU": "0",
        "ApprovedNumKU": 0,
        "ApprovedPriceKU": 0,
        "DeliveryLeadTimeTypeKU": "",
        "DeliveryLeadTimeTypeNameKU": "",
        "DutiesFormDailyDiv": "00",
        "DutiesFormSpotDiv": "0"
      },
      {
        "PromotionNo": "S74371",
        "PromotionName": "",
        "PromotionDiv": "S",
        "OrderCode": "2025300",
        "MediumType": "041",
        "PCode": "P2589797",
        "GuideGoodsName": "国産米をふっくら炊いた白かゆ",
        "GuideStandardName": "２６０ｇ（１５個入）",
        "ConsumeTaxDiv": "0",
        "ConsumeTaxRate": "8",
        "SetDelivGoodsName": "スタートセット白かゆ",
        "SetDelivGoodsNameKana": "ｺｸｻﾝﾏｲｦﾌﾂｸﾗﾀｲﾀｼ",
        "SetDelivStandardName": "２６０ｇ（１５個入）",
        "SetDelivStandardNameKana": "260G",
        "DeliveryGoodsNameKanji": "国産米をふっくら炊いた白かゆ",
        "DeliveryGoodsNameKana": "ｺｸｻﾝﾏｲｦﾌﾂｸﾗﾀｲﾀｼ",
        "DeliveryStandardNameKanji": "２６０ｇ（１５個入）",
        "DeliveryStandardNameKana": "260G",
        "SetPlanDiv": "2",
        "SetPlanDivName": "2：子",
        "AcceptDiv": "0",
        "AcceptDivName": "0：不可",
        "SupplyDiv": "1",
        "SupplyDivName": "1：可能",
        "SingleOrderFlag": "1",
        "SingleOrderFlagName": "1：可能",
        "HandlingFlgIB": "1",
        "ThisTimeSupplyPriceIB": 298,
        "ThisTimeCostPriceIB": 204.2,
        "PromotionFlgIB": "1",
        "ApprovedNumIB": 1,
        "ApprovedPriceIB": 298,
        "DeliveryLeadTimeTypeIB": "01",
        "DeliveryLeadTimeTypeNameIB": "01：翌週",
        "HandlingFlgTO": "1",
        "ThisTimeSupplyPriceTO": 298,
        "ThisTimeCostPriceTO": 204.2,
        "PromotionFlgTO": "1",
        "ApprovedNumTO": 1,
        "ApprovedPriceTO": 298,
        "DeliveryLeadTimeTypeTO": "01",
        "DeliveryLeadTimeTypeNameTO": "01：翌週",
        "HandlingFlgGU": "1",
        "ThisTimeSupplyPriceGU": 298,
        "ThisTimeCostPriceGU": 204.2,
        "PromotionFlgGU": "1",
        "ApprovedNumGU": 1,
        "ApprovedPriceGU": 298,
        "DeliveryLeadTimeTypeGU": "01",
        "DeliveryLeadTimeTypeNameGU": "01：翌週",
        "HandlingFlgTI": "1",
        "ThisTimeSupplyPriceTI": 298,
        "ThisTimeCostPriceTI": 204.2,
        "PromotionFlgTI": "1",
        "ApprovedNumTI": 1,
        "ApprovedPriceTI": 298,
        "DeliveryLeadTimeTypeTI": "01",
        "DeliveryLeadTimeTypeNameTI": "01：翌週",
        "HandlingFlgSA": "1",
        "ThisTimeSupplyPriceSA": 298,
        "ThisTimeCostPriceSA": 204.2,
        "PromotionFlgSA": "1",
        "ApprovedNumSA": 1,
        "ApprovedPriceSA": 298,
        "DeliveryLeadTimeTypeSA": "01",
        "DeliveryLeadTimeTypeNameSA": "01：翌週",
        "HandlingFlgTK": "1",
        "ThisTimeSupplyPriceTK": 298,
        "ThisTimeCostPriceTK": 204.2,
        "PromotionFlgTK": "1",
        "ApprovedNumTK": 1,
        "ApprovedPriceTK": 298,
        "DeliveryLeadTimeTypeTK": "01",
        "DeliveryLeadTimeTypeNameTK": "01：翌週",
        "HandlingFlgNA": "1",
        "ThisTimeSupplyPriceNA": 298,
        "ThisTimeCostPriceNA": 204.2,
        "PromotionFlgNA": "1",
        "ApprovedNumNA": 1,
        "ApprovedPriceNA": 298,
        "DeliveryLeadTimeTypeNA": "01",
        "DeliveryLeadTimeTypeNameNA": "01：翌週",
        "HandlingFlgNI": "1",
        "ThisTimeSupplyPriceNI": 298,
        "ThisTimeCostPriceNI": 204.2,
        "PromotionFlgNI": "1",
        "ApprovedNumNI": 1,
        "ApprovedPriceNI": 298,
        "DeliveryLeadTimeTypeNI": "01",
        "DeliveryLeadTimeTypeNameNI": "01：翌週",
        "HandlingFlgKU": "0",
        "ThisTimeSupplyPriceKU": 0,
        "ThisTimeCostPriceKU": 0,
        "PromotionFlgKU": "0",
        "ApprovedNumKU": 0,
        "ApprovedPriceKU": 0,
        "DeliveryLeadTimeTypeKU": "",
        "DeliveryLeadTimeTypeNameKU": "",
        "DutiesFormDailyDiv": "00",
        "DutiesFormSpotDiv": "0"
      },
      {
        "PromotionNo": "S74371",
        "PromotionName": "",
        "PromotionDiv": "S",
        "OrderCode": "2025300",
        "MediumType": "041",
        "PCode": "P2592527",
        "GuideGoodsName": "国産野菜で作ったなめらかキューブ　ほうれん草",
        "GuideStandardName": "１２０ｇ（１２個入）",
        "ConsumeTaxDiv": "0",
        "ConsumeTaxRate": "8",
        "SetDelivGoodsName": "スタートセットほうれん草",
        "SetDelivGoodsNameKana": "ﾅﾒﾗｶｷﾕｰﾌﾞﾎｳﾚﾝｿｳ",
        "SetDelivStandardName": "１２０ｇ（１２個入）",
        "SetDelivStandardNameKana": "120G",
        "DeliveryGoodsNameKanji": "なめらかキューブ　ほうれん草",
        "DeliveryGoodsNameKana": "ﾅﾒﾗｶｷﾕｰﾌﾞﾎｳﾚﾝｿｳ",
        "DeliveryStandardNameKanji": "１２０ｇ（１２個入）",
        "DeliveryStandardNameKana": "120G",
        "SetPlanDiv": "2",
        "SetPlanDivName": "2：子",
        "AcceptDiv": "0",
        "AcceptDivName": "0：不可",
        "SupplyDiv": "1",
        "SupplyDivName": "1：可能",
        "SingleOrderFlag": "1",
        "SingleOrderFlagName": "1：可能",
        "HandlingFlgIB": "1",
        "ThisTimeSupplyPriceIB": 298,
        "ThisTimeCostPriceIB": 198.7,
        "PromotionFlgIB": "1",
        "ApprovedNumIB": 1,
        "ApprovedPriceIB": 298,
        "DeliveryLeadTimeTypeIB": "01",
        "DeliveryLeadTimeTypeNameIB": "01：翌週",
        "HandlingFlgTO": "1",
        "ThisTimeSupplyPriceTO": 298,
        "ThisTimeCostPriceTO": 198.7,
        "PromotionFlgTO": "1",
        "ApprovedNumTO": 1,
        "ApprovedPriceTO": 298,
        "DeliveryLeadTimeTypeTO": "01",
        "DeliveryLeadTimeTypeNameTO": "01：翌週",
        "HandlingFlgGU": "1",
        "ThisTimeSupplyPriceGU": 298,
        "ThisTimeCostPriceGU": 198.7,
        "PromotionFlgGU": "1",
        "ApprovedNumGU": 1,
        "ApprovedPriceGU": 298,
        "DeliveryLeadTimeTypeGU": "01",
        "DeliveryLeadTimeTypeNameGU": "01：翌週",
        "HandlingFlgTI": "1",
        "ThisTimeSupplyPriceTI": 298,
        "ThisTimeCostPriceTI": 198.7,
        "PromotionFlgTI": "1",
        "ApprovedNumTI": 1,
        "ApprovedPriceTI": 298,
        "DeliveryLeadTimeTypeTI": "01",
        "DeliveryLeadTimeTypeNameTI": "01：翌週",
        "HandlingFlgSA": "1",
        "ThisTimeSupplyPriceSA": 298,
        "ThisTimeCostPriceSA": 198.7,
        "PromotionFlgSA": "1",
        "ApprovedNumSA": 1,
        "ApprovedPriceSA": 298,
        "DeliveryLeadTimeTypeSA": "01",
        "DeliveryLeadTimeTypeNameSA": "01：翌週",
        "HandlingFlgTK": "1",
        "ThisTimeSupplyPriceTK": 298,
        "ThisTimeCostPriceTK": 198.7,
        "PromotionFlgTK": "1",
        "ApprovedNumTK": 1,
        "ApprovedPriceTK": 298,
        "DeliveryLeadTimeTypeTK": "01",
        "DeliveryLeadTimeTypeNameTK": "01：翌週",
        "HandlingFlgNA": "1",
        "ThisTimeSupplyPriceNA": 298,
        "ThisTimeCostPriceNA": 198.7,
        "PromotionFlgNA": "1",
        "ApprovedNumNA": 1,
        "ApprovedPriceNA": 298,
        "DeliveryLeadTimeTypeNA": "01",
        "DeliveryLeadTimeTypeNameNA": "01：翌週",
        "HandlingFlgNI": "1",
        "ThisTimeSupplyPriceNI": 298,
        "ThisTimeCostPriceNI": 198.7,
        "PromotionFlgNI": "1",
        "ApprovedNumNI": 1,
        "ApprovedPriceNI": 298,
        "DeliveryLeadTimeTypeNI": "01",
        "DeliveryLeadTimeTypeNameNI": "01：翌週",
        "HandlingFlgKU": "0",
        "ThisTimeSupplyPriceKU": 0,
        "ThisTimeCostPriceKU": 0,
        "PromotionFlgKU": "0",
        "ApprovedNumKU": 0,
        "ApprovedPriceKU": 0,
        "DeliveryLeadTimeTypeKU": "",
        "DeliveryLeadTimeTypeNameKU": "",
        "DutiesFormDailyDiv": "00",
        "DutiesFormSpotDiv": "0"
      },
      {
        "PromotionNo": "S74371",
        "PromotionName": "",
        "PromotionDiv": "S",
        "OrderCode": "2025300",
        "MediumType": "004",
        "PCode": "P2622732",
        "GuideGoodsName": "離乳食ガイドブック",
        "GuideStandardName": "１冊",
        "ConsumeTaxDiv": "0",
        "ConsumeTaxRate": "10",
        "SetDelivGoodsName": "スタートセットガイドブック",
        "SetDelivGoodsNameKana": "ﾘﾆﾕｳｼﾖｸｶﾞｲﾄﾞﾌﾞﾂ",
        "SetDelivStandardName": "１冊",
        "SetDelivStandardNameKana": "1ｻﾂ",
        "DeliveryGoodsNameKanji": "離乳食ガイドブック",
        "DeliveryGoodsNameKana": "ﾘﾆﾕｳｼﾖｸｶﾞｲﾄﾞﾌﾞﾂ",
        "DeliveryStandardNameKanji": "１冊",
        "DeliveryStandardNameKana": "1ｻﾂ",
        "SetPlanDiv": "2",
        "SetPlanDivName": "2：子",
        "AcceptDiv": "0",
        "AcceptDivName": "0：不可",
        "SupplyDiv": "1",
        "SupplyDivName": "1：可能",
        "SingleOrderFlag": "0",
        "SingleOrderFlagName": "0：不可",
        "HandlingFlgIB": "1",
        "ThisTimeSupplyPriceIB": 0,
        "ThisTimeCostPriceIB": 0,
        "PromotionFlgIB": "1",
        "ApprovedNumIB": 1,
        "ApprovedPriceIB": 0,
        "DeliveryLeadTimeTypeIB": "01",
        "DeliveryLeadTimeTypeNameIB": "01：翌週",
        "HandlingFlgTO": "1",
        "ThisTimeSupplyPriceTO": 0,
        "ThisTimeCostPriceTO": 0,
        "PromotionFlgTO": "1",
        "ApprovedNumTO": 1,
        "ApprovedPriceTO": 0,
        "DeliveryLeadTimeTypeTO": "01",
        "DeliveryLeadTimeTypeNameTO": "01：翌週",
        "HandlingFlgGU": "1",
        "ThisTimeSupplyPriceGU": 0,
        "ThisTimeCostPriceGU": 0,
        "PromotionFlgGU": "1",
        "ApprovedNumGU": 1,
        "ApprovedPriceGU": 0,
        "DeliveryLeadTimeTypeGU": "01",
        "DeliveryLeadTimeTypeNameGU": "01：翌週",
        "HandlingFlgTI": "1",
        "ThisTimeSupplyPriceTI": 0,
        "ThisTimeCostPriceTI": 0,
        "PromotionFlgTI": "1",
        "ApprovedNumTI": 1,
        "ApprovedPriceTI": 0,
        "DeliveryLeadTimeTypeTI": "01",
        "DeliveryLeadTimeTypeNameTI": "01：翌週",
        "HandlingFlgSA": "1",
        "ThisTimeSupplyPriceSA": 0,
        "ThisTimeCostPriceSA": 0,
        "PromotionFlgSA": "1",
        "ApprovedNumSA": 1,
        "ApprovedPriceSA": 0,
        "DeliveryLeadTimeTypeSA": "01",
        "DeliveryLeadTimeTypeNameSA": "01：翌週",
        "HandlingFlgTK": "1",
        "ThisTimeSupplyPriceTK": 0,
        "ThisTimeCostPriceTK": 0,
        "PromotionFlgTK": "1",
        "ApprovedNumTK": 1,
        "ApprovedPriceTK": 0,
        "DeliveryLeadTimeTypeTK": "01",
        "DeliveryLeadTimeTypeNameTK": "01：翌週",
        "HandlingFlgNA": "1",
        "ThisTimeSupplyPriceNA": 0,
        "ThisTimeCostPriceNA": 0,
        "PromotionFlgNA": "1",
        "ApprovedNumNA": 1,
        "ApprovedPriceNA": 0,
        "DeliveryLeadTimeTypeNA": "01",
        "DeliveryLeadTimeTypeNameNA": "01：翌週",
        "HandlingFlgNI": "1",
        "ThisTimeSupplyPriceNI": 0,
        "ThisTimeCostPriceNI": 0,
        "PromotionFlgNI": "1",
        "ApprovedNumNI": 1,
        "ApprovedPriceNI": 0,
        "DeliveryLeadTimeTypeNI": "01",
        "DeliveryLeadTimeTypeNameNI": "01：翌週",
        "HandlingFlgKU": "0",
        "ThisTimeSupplyPriceKU": 0,
        "ThisTimeCostPriceKU": 0,
        "PromotionFlgKU": "0",
        "ApprovedNumKU": 0,
        "ApprovedPriceKU": 0,
        "DeliveryLeadTimeTypeKU": "",
        "DeliveryLeadTimeTypeNameKU": "",
        "DutiesFormDailyDiv": "00",
        "DutiesFormSpotDiv": "0"
      },
      {
        "PromotionNo": "S74371",
        "PromotionName": "",
        "PromotionDiv": "S",
        "OrderCode": "2025300",
        "MediumType": "041",
        "PCode": "P2664628",
        "GuideGoodsName": "北海道のうらごしにんじん",
        "GuideStandardName": "３１０ｇ（１５個入）",
        "ConsumeTaxDiv": "0",
        "ConsumeTaxRate": "8",
        "SetDelivGoodsName": "スタートセットにんじん",
        "SetDelivGoodsNameKana": "ﾎｯｶｲﾄﾞｳﾉｳﾗｺﾞｼﾆﾝ",
        "SetDelivStandardName": "３１０ｇ（１５個入）",
        "SetDelivStandardNameKana": "310G(15ｺｲﾘ",
        "DeliveryGoodsNameKanji": "北海道のうらごしにんじん",
        "DeliveryGoodsNameKana": "ﾎｯｶｲﾄﾞｳﾉｳﾗｺﾞｼﾆﾝ",
        "DeliveryStandardNameKanji": "３１０ｇ（１５個入）",
        "DeliveryStandardNameKana": "310G(15ｺｲﾘ",
        "SetPlanDiv": "2",
        "SetPlanDivName": "2：子",
        "AcceptDiv": "0",
        "AcceptDivName": "0：不可",
        "SupplyDiv": "1",
        "SupplyDivName": "1：可能",
        "SingleOrderFlag": "1",
        "SingleOrderFlagName": "1：可能",
        "HandlingFlgIB": "1",
        "ThisTimeSupplyPriceIB": 350,
        "ThisTimeCostPriceIB": 245.4,
        "PromotionFlgIB": "1",
        "ApprovedNumIB": 1,
        "ApprovedPriceIB": 350,
        "DeliveryLeadTimeTypeIB": "01",
        "DeliveryLeadTimeTypeNameIB": "01：翌週",
        "HandlingFlgTO": "1",
        "ThisTimeSupplyPriceTO": 350,
        "ThisTimeCostPriceTO": 245.4,
        "PromotionFlgTO": "1",
        "ApprovedNumTO": 1,
        "ApprovedPriceTO": 350,
        "DeliveryLeadTimeTypeTO": "01",
        "DeliveryLeadTimeTypeNameTO": "01：翌週",
        "HandlingFlgGU": "1",
        "ThisTimeSupplyPriceGU": 350,
        "ThisTimeCostPriceGU": 245.4,
        "PromotionFlgGU": "1",
        "ApprovedNumGU": 1,
        "ApprovedPriceGU": 350,
        "DeliveryLeadTimeTypeGU": "01",
        "DeliveryLeadTimeTypeNameGU": "01：翌週",
        "HandlingFlgTI": "1",
        "ThisTimeSupplyPriceTI": 350,
        "ThisTimeCostPriceTI": 245.4,
        "PromotionFlgTI": "1",
        "ApprovedNumTI": 1,
        "ApprovedPriceTI": 350,
        "DeliveryLeadTimeTypeTI": "01",
        "DeliveryLeadTimeTypeNameTI": "01：翌週",
        "HandlingFlgSA": "1",
        "ThisTimeSupplyPriceSA": 350,
        "ThisTimeCostPriceSA": 245.4,
        "PromotionFlgSA": "1",
        "ApprovedNumSA": 1,
        "ApprovedPriceSA": 350,
        "DeliveryLeadTimeTypeSA": "01",
        "DeliveryLeadTimeTypeNameSA": "01：翌週",
        "HandlingFlgTK": "1",
        "ThisTimeSupplyPriceTK": 350,
        "ThisTimeCostPriceTK": 245.4,
        "PromotionFlgTK": "1",
        "ApprovedNumTK": 1,
        "ApprovedPriceTK": 350,
        "DeliveryLeadTimeTypeTK": "01",
        "DeliveryLeadTimeTypeNameTK": "01：翌週",
        "HandlingFlgNA": "1",
        "ThisTimeSupplyPriceNA": 350,
        "ThisTimeCostPriceNA": 245.4,
        "PromotionFlgNA": "1",
        "ApprovedNumNA": 1,
        "ApprovedPriceNA": 350,
        "DeliveryLeadTimeTypeNA": "01",
        "DeliveryLeadTimeTypeNameNA": "01：翌週",
        "HandlingFlgNI": "1",
        "ThisTimeSupplyPriceNI": 350,
        "ThisTimeCostPriceNI": 245.4,
        "PromotionFlgNI": "1",
        "ApprovedNumNI": 1,
        "ApprovedPriceNI": 350,
        "DeliveryLeadTimeTypeNI": "01",
        "DeliveryLeadTimeTypeNameNI": "01：翌週",
        "HandlingFlgKU": "0",
        "ThisTimeSupplyPriceKU": 0,
        "ThisTimeCostPriceKU": 0,
        "PromotionFlgKU": "0",
        "ApprovedNumKU": 0,
        "ApprovedPriceKU": 0,
        "DeliveryLeadTimeTypeKU": "",
        "DeliveryLeadTimeTypeNameKU": "",
        "DutiesFormDailyDiv": "00",
        "DutiesFormSpotDiv": "0"
      }
    ]
  }
}

const getSetPlanGoodsInfoResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": [
      {
        "PCode": "P2669137",
        "MediumType": "001",
        "GuideGoodsName": "３種の海鮮丼（まぐろ・めかぶ・紅鮭いくら）",
        "GuideStandardName": "１００ｇ（５０ｇ×２）",
        "ConsumeTaxDiv": "0",
        "ConsumeTaxRate": "8",
        "SetDelivGoodsName": "",
        "SetDelivGoodsNameKana": "",
        "SetDelivStandardName": "",
        "SetDelivStandardNameKana": "",
        "DeliveryGoodsNameKanji": "３種の海鮮丼",
        "DeliveryGoodsNameKana": "ｻﾝｼｭﾏｸﾞﾛﾒｶﾌﾞｲｸﾗ",
        "DeliveryStandardNameKanji": "５０ｇ×２",
        "DeliveryStandardNameKana": "50GX2",
        "HandlingFlgIB": "1",
        "ThisTimeSupplyPriceIB": 358,
        "ThisTimeCostPriceIB": 253,
        "DeliveryLeadTimeTypeIB": "01",
        "DeliveryLeadTimeTypeNameIB": "01：翌週",
        "HandlingFlgTO": "1",
        "ThisTimeSupplyPriceTO": 358,
        "ThisTimeCostPriceTO": 253,
        "DeliveryLeadTimeTypeTO": "01",
        "DeliveryLeadTimeTypeNameTO": "01：翌週",
        "HandlingFlgGU": "1",
        "ThisTimeSupplyPriceGU": 358,
        "ThisTimeCostPriceGU": 253,
        "DeliveryLeadTimeTypeGU": "01",
        "DeliveryLeadTimeTypeNameGU": "01：翌週",
        "HandlingFlgTI": "1",
        "ThisTimeSupplyPriceTI": 358,
        "ThisTimeCostPriceTI": 253,
        "DeliveryLeadTimeTypeTI": "01",
        "DeliveryLeadTimeTypeNameTI": "01：翌週",
        "HandlingFlgSA": "1",
        "ThisTimeSupplyPriceSA": 358,
        "ThisTimeCostPriceSA": 253,
        "DeliveryLeadTimeTypeSA": "01",
        "DeliveryLeadTimeTypeNameSA": "01：翌週",
        "HandlingFlgTK": "1",
        "ThisTimeSupplyPriceTK": 358,
        "ThisTimeCostPriceTK": 253,
        "DeliveryLeadTimeTypeTK": "01",
        "DeliveryLeadTimeTypeNameTK": "01：翌週",
        "HandlingFlgNA": "1",
        "ThisTimeSupplyPriceNA": 358,
        "ThisTimeCostPriceNA": 253,
        "DeliveryLeadTimeTypeNA": "01",
        "DeliveryLeadTimeTypeNameNA": "01：翌週",
        "HandlingFlgNI": "1",
        "ThisTimeSupplyPriceNI": 358,
        "ThisTimeCostPriceNI": 253,
        "DeliveryLeadTimeTypeNI": "01",
        "DeliveryLeadTimeTypeNameNI": "01：翌週",
        "HandlingFlgKU": "0",
        "ThisTimeSupplyPriceKU": 0,
        "ThisTimeCostPriceKU": 0,
        "DeliveryLeadTimeTypeKU": "",
        "DeliveryLeadTimeTypeNameKU": "",
        "PromotionFlg": "0",
        "DutiesFormDailyDiv": "00",
        "DutiesFormSpotDiv": "0",
        "AccessDiv": "2"
      }
    ]
  }
}
